import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  ProductOptionCreateInput,
  ProductOptionUpdateInput,
} from "@/modules/options/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateProductOption } from "../api/queries";
import { OptionsFormTour, useOptionsFormTour } from "../tour";
import { OptionForm } from "../ui/OptionForm";

export function OptionCreatePage() {
  const nav = useNavigate({ from: "/app/catalog/options/new" });
  const createOption = useCreateProductOption();
  const { run, handleJoyrideCallback, startTour } = useOptionsFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຕົວເລືອກ", to: "/app/catalog/options" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ Product Option{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມ option ໃໝ່ພ້ອມຄ່າ (Red, Blue / S, M, L) ສໍາລັບການສ້າງ variant.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/catalog/options" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <OptionForm
            mode="create"
            onSubmit={async (
              values: ProductOptionCreateInput | ProductOptionUpdateInput,
            ) => {
              await createOption.mutateAsync(
                values as ProductOptionCreateInput,
              );
              nav({ to: "/app/catalog/options" } as any);
            }}
            onCancel={() => nav({ to: "/app/catalog/options" } as any)}
            submitting={createOption.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <OptionsFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
